import { render, staticRenderFns } from "./linkTaskFeature.vue?vue&type=template&id=2f3a419f&scoped=true&"
import script from "./linkTaskFeature.vue?vue&type=script&lang=js&"
export * from "./linkTaskFeature.vue?vue&type=script&lang=js&"
import style0 from "./linkTaskFeature.vue?vue&type=style&index=0&id=2f3a419f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a419f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f3a419f')) {
      api.createRecord('2f3a419f', component.options)
    } else {
      api.reload('2f3a419f', component.options)
    }
    module.hot.accept("./linkTaskFeature.vue?vue&type=template&id=2f3a419f&scoped=true&", function () {
      api.rerender('2f3a419f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/roadmap/linkTaskFeature.vue"
export default component.exports